import { createAsyncThunk } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "@/store/store";

/**
 * Pre-typed version of createAsyncThunk with app-specific types
 * This avoids circular dependencies by being in a separate file
 */
export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
}>();
